export const STATE_NAMES = {
  login: 'login',
  forgotPassword: 'forgotPassword',
  changePassword: 'changePassword',
  app: 'app',
  home: 'app.home',
  main: 'app.main',
  chat: 'app.chat',
  travels: 'app.travels',
  travel: 'app.travel',
  events: 'app.events',
  userProfile: 'app.userProfile',
};
